import React, { useState } from 'react';
import { Button, Modal } from '@mantine/core';
import { Plus } from 'tabler-icons-react';
import { LocationForm } from './LocationForm';
import { useTranslation } from 'react-i18next';

export function LocationCreateDialog() {
  const { t } = useTranslation();
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Button
        color="green"
        size="md"
        variant="light"
        leftIcon={<Plus />}
        onClick={() => setOpened(true)}
      >
        {t('LocationCreateDialog.Title')}
      </Button>
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        size="lg"
        title={t('LocationCreateDialog.Title')}
      >
        <LocationForm create={true} onFinish={() => setOpened(false)} />
      </Modal>
    </>
  );
}
